import { combineReducers } from 'redux';
import currentSopReducer from './currentSopReducer';
import sopListReducer from './sopListReducer';

/* global Redux */
const sopReducer = function() {
  return combineReducers({
    list: sopListReducer,
    current: currentSopReducer,
  });
};

export default sopReducer();
